/*
 *  -----------------------------------------------------------------------
 *    <copyright file="data-source-selector.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { orderBy } from '@progress/kendo-data-query';
import React, { useEffect } from 'react';

import { useLocalState, useLogger, useTranslation } from 'hooks';
import SelectWithCategories from 'views/components/core/select-with-categories';

const DataSourceSelector = ({
    label,
    onChange,
    fieldSelect,
    value,
    labelField,
    showWarning,
    filterable = false,
    error,
    searchable = true,
    showDefault = true,
    showFilters = true,
    customClassName = null as any,
    tables = null as any,
    tag = null as any,
    disabled,
    appendPopupToSelect,
}: any) => {
    const { t } = useTranslation();
    const { state: localState } = useLocalState();
    const Logger = useLogger();

    const getSeriesRowDataOptions = () => {
        let options =
            localState?.dataSources
                ?.filter(
                    (dataSource: any) =>
                        ((dataSource.default && showDefault) || (!dataSource.default && showFilters)) &&
                        (!tables || tables.indexOf(dataSource.table) >= 0) &&
                        (!tag || dataSource.tags?.indexOf(tag) >= 0),
                )
                ?.map((dataSource: any) => ({
                    id: dataSource.id,
                    text: dataSource.name,
                    active: true,
                    default: false,
                    table: dataSource.table,
                })) ?? [];
        options = orderBy(options, [{ field: 'text', dir: 'asc' }]);
        options.unshift({ id: '', text: t('admin:selectSeriesRowData'), active: true, default: true });
        return options;
    };

    const seriesRowDataOptions = getSeriesRowDataOptions();

    useEffect(() => {
        Logger.log(`${label}: Dropdown Items:`, seriesRowDataOptions);
    }, [tables]);

    return (
        <SelectWithCategories
            label={label}
            dataArray={seriesRowDataOptions}
            onChange={() => (event: any) => {
                onChange(event?.target?.value);
            }}
            fieldSelect={fieldSelect}
            currentState={value || ''}
            labelField={labelField}
            showWarning={showWarning}
            filterable={filterable}
            customClassName={customClassName}
            error={error}
            searchable={searchable}
            disabled={disabled}
            appendPopupToSelect={appendPopupToSelect}
        />
    );
};

export default DataSourceSelector;
